/**
 * Dragon app colors, that need to be used in js
 *
 * @WARN This colors are represented in css! If you change them in css, you should update them here to!
 */
export const ISP_COLORS = {
  // --isp-background-additional
  backgroundAdditional: '#ffffff',
  // no variable for that
  backgroundAdditionalTransparent: '#ffffffb3',
  // --isp-border-default
  borderDefault: '#d9d9d9',
  // --isp-background-list-3
  backgroundList3: '#e9f2ff',
  // --isp-table-background-hover-1
  tableBackgroundHover1: '#e0ebff',
  // --isp-graph-light-blue
  graphLightBlue: '#bbebfb',
  // --isp-graph-light-blue-1
  graphLightBlue1: '#bbebfb',
  // --isp-graph-bright-blue
  graphBrightBlue: '#7ab8ff',
  // --isp-graph-bright-blue-1
  graphBrightBlue1: '#7ab8ff',
  // --isp-text-blue
  textBlue: '#0279c0',
  // --isp-border-interactive
  borderInteractive: '#0063db',
  // --isp-text-interactive
  textInteractive: '#0063db',
  // --isp-text-interactive__hover
  textInteractiveHover: '#003e89',
  // --isp-graph-light-purple
  graphLightPurple: '#abbafc',
  // --isp-graph-dark-blue
  graphDarkBlue: '#6e74bd',
  // --isp-text-main
  textMain: '#17212a',
  // --isp-text-danger
  textDanger: '#db0444',
  // --isp-background-danger
  backgroundDanger: '#db0444',
  // --isp-background-danger-inline__active
  backgroundDangerInlineActive: '#f8cdda',
  // --isp-background-warning
  backgroundWarning: '#f88b25',
  // --isp-background-accent
  backgroundAccent: '#ffe03a',
  // --isp-background-warning-secondary
  backgroundWarningSecondary: '#fffceb',
  // --isp-text-success
  textSuccess: '#1b7f37',
  // --isp-graph-green
  graphGreen: '#65c84d',
  // --isp-text-cyan
  textCyan: '#0b9898',
  // --isp-graph-orange
  graphOrange: '#ff7a1a',
};

export const ISP_COLORS_VAR = {
  backgroundAdditional: '--isp-background-additional',
  textMain: '--isp-text-main',
  textAdditional: '--isp-text-additional',
  backgroundList3: '--isp-background-list-3',
  textSuccess: '--isp-text-success',
  textBlue: '--isp-text-blue',
  textDanger: '--isp-text-danger',
  textCyan: '--isp-text-cyan',
  textWarning: '--isp-text-warning',
  iconInfo: '--isp-icon-info',
  iconSuccess: '--isp-icon-success',
  iconWarning: '--isp-icon-warning',
};

export const ISP_TYPOGRAPHY_VAR = {
  bold: '--isp-font-weight-bold',
};
